/**
 * SIN ZOOM AL TOCAR UN CAMPO EN IPHONE (21-oct-2026).
 *
 * > *"al menos en login esta muy a la derecha y no centrado"*
 *
 * 🔴 Safari en iPhone acerca la página al enfocar un campo con letra de menos de 16 px —los de la plataforma van de 13 a
 * 15 px— y no la regresa al salir. El login quedaba ampliado y corrido a la derecha, y la pantalla siguiente también.
 * Con el teléfono emulado a 390 px el login está centrado (comprobado): el corrimiento lo hace el zoom.
 *
 * 🔑 `maximum-scale=1` en el viewport lo evita, y se pone **solo en iPhone y iPad**: ahí Safari lo ignora para el
 * pellizco (desde iOS 10 el usuario puede ampliar igual), así que no se pierde accesibilidad. En Android sí bloquearía
 * el pellizco, y ahí no existe este zoom: no se toca.
 *
 * 📌 Se descartó subir todos los campos a 16 px en el teléfono: cambia el tamaño de cada campo de la plataforma y podía
 * desacomodar los que van en espacios justos (el Protect Time, los filtros).
 */
export const preventIosInputZoom = (): void => {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') return;

  const ios =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    /** iPadOS se presenta como Mac; lo delata la pantalla táctil. */
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!ios) return;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || /maximum-scale/.test(meta.content)) return;
  meta.content = `${meta.content}, maximum-scale=1`;
};
